import { render } from "./DelegationList.vue?vue&type=template&id=247613cc&scoped=true&ts=true"
import script from "./DelegationList.vue?vue&type=script&lang=ts"
export * from "./DelegationList.vue?vue&type=script&lang=ts"

import "./DelegationList.vue?vue&type=style&index=0&id=247613cc&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247613cc"]])

export default __exports__